// extracted by mini-css-extract-plugin
export default {"subtitle":"MyNotificationSettings_subtitle__C6xT4","loading":"MyNotificationSettings_loading__+eYur"};